import { Component, OnInit } from '@angular/core';
import { ModalSize, SuiModalService } from '@richardlt/ng2-semantic-ui';
import { AppFilter, ConfirmModal } from 'src/modules/shared';
import {
  WorkflowNewModal,
  WorkflowGroupModal,
  WorkflowGroupAddModal,
} from '../../../modals';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { APIKeyService, ApplicationService } from '../../../services';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import {
  debounceTime,
  takeUntil,
  distinctUntilChanged,
  tap,
  map,
} from 'rxjs/operators';
@Component({
  selector: 'app-api-key-list',
  templateUrl: './api-key-list.component.html',
  styleUrls: ['./api-key-list.component.scss'],
})
export class ApiKeyListComponent implements OnInit {
  organizationId: string;
  private unsubscribe$: Subject<void> = new Subject<void>();
  apiKeys = [];
  projectId: string;
  success: any;
  error: any;
  pending: boolean;
  filter: AppFilter = new AppFilter();
  totalItems: number = 5;
  rows: number = 2;
  currentPage: number = 1;
  maxSize: number = 7;
  searchFilter: string = '';
  clipSuccess: string;
  appUserId: string;
  applicationForm: FormGroup
  applicationList: any;
  constructor(
    private modalService: SuiModalService,
    private location: Location,
    private activatedRoute: ActivatedRoute,
    private apiKeySvc: APIKeyService,
    private applicationSvc: ApplicationService,
    private fb: FormBuilder
  ) {
    this.applicationForm = this.fb.group({
        applicationId: ['', Validators.required]
    })
    this.applicationSvc.getApplications({ params: this.filter }).subscribe((res) => {
      this.applicationList = res['rows']
    })
    this.appUserId = JSON.parse(window.localStorage.getItem('user'))[
      'appUserId'
    ];
    // this.activatedRoute.parent.params.subscribe((params) => {
    // 	this.projectId = params['id'];
    // });
    this.organizationId = window.localStorage.getItem('organizationId');
    this.filter = new AppFilter({ sidx: 'dateCreated', rows: 15, page: 1 });
    this.filter.filters = JSON.stringify(this.searchFilter);
    this.getPage(1);
  }
  logSuccess(event) {
    this.success = 'Api key copied';
    setTimeout(() => {
      this.clipSuccess = null;
    }, 1000);
  }

  logError(event) {
    console.log(event);
  }

  goBack() {
    this.location.back();
  }
  searchRecords(event) {
    this.searchFilter = event;
    this.getPage(1);
  }
  //handle sorting records
  sortRecords(search) {
    this.filter.sord = search;
    this.getPage(1);
  }

  //handles rows display
  displayRecords(row) {
    this.filter['rows'] = row;
    this.getPage(1);
  }

  nextPage(page: number) {
    //get and assign current page
    this.currentPage = page;
    this.getPage(this.currentPage);
  }

  generateKey() {
    this.pending = true;
    this.success = null;
    this.error = null;
    this.apiKeySvc.generateApiKey({ appUserId: this.appUserId, applicationId: this.applicationForm.value.applicationId }).subscribe(
      (res) => {
        this.pending = false;
        this.success = ' Api key generated successfully';
        setTimeout(() => {
          this.getPage(1);
        }, 700);
      },
      (error) => {
        this.pending = false;
        this.error = error.error.errorMessage ? error.error.errorMessage
                                              : error.error ? error.error
                                              : error;
      }
    );
  }

  deleteKey(key) {
    this.pending = true;
    this.apiKeySvc
      .deleteApiKey({
        apiKey: key,
        organizationId: this.organizationId,
      })
      .subscribe(
        (res) => {
          this.pending = false;
          this.success = 'Api Key deleted successfully';
          this.getPage(1);
        },
        (error) => {
          this.error = error.error.errorMessage ? error.error.errorMessage
                                                : error.error ? error.error
                                                : error;
          this.pending = false;
        }
      );
  }
  // get page request options with filter params
  getPage(page) {
    this.filter.page = page;
    this.filter.filters = this.searchFilter;
    this.pending = true;
    this.apiKeySvc
      .getApiKeys({ organizationId: this.organizationId, params: this.filter })
      .pipe(
        tap((res) => {
          this.totalItems = +res['records'];
          this.currentPage = page;
          this.rows = +this.filter.rows;
        }),
        map((res: any) => res['rows']),
        takeUntil(this.unsubscribe$)
      )
      .subscribe(
        (res: any[]) => {
          this.pending = false;
          this.apiKeys = res;
        },
        (error) => {
          this.pending = false;
          if (error.errorCode === 200401) {
            this.error = error['userMessage'];
          } else {
            this.error = error.error.errorMessage ? error.error.errorMessage
                                                  : error.error ? error.error
                                                  : error;
          }
        }
      );
  }

  generateKeyModal() {
    this.modalService
      .open(
        new ConfirmModal(
          'Delete API Key?',
          'Are you sure you want to delete this API Key?',
          ModalSize.Tiny
        )
      )
      .onApprove(() => {
        this.generateKey();
      });
  }

  delete(app) {
    this.modalService
      .open(
        new ConfirmModal(
          'Delete API Key?',
          'Are you sure you want to delete this API Key?',
          ModalSize.Tiny
        )
      )
      .onApprove(() => {
        this.deleteKey(app.apiKey);
      })
      .onDeny(() => {});
  }
  ngOnInit(): void {}
}
